<template>
    <div class="message" :class="`is-${type}`">
        <!-- eslint-disable vue/no-v-html -->
        <p v-if="title" class="message-title" v-html="title" />
        <p class="message-content">
            <slot />
        </p>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: false,
            default: 'error',
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
    },

    data: () => ({
        validTypes: [
            'error',
        ],
        defaultType: 'error',
    }),

    computed: {
        /**
         * Returns vaid mesage type.
         *
         * @returns {string}  Valid type.
         */
        validType() {
            return this.validTypes.includes(this.type) ? this.type : this.defaultType;
        },
    },
};
</script>
